import React, { useEffect, useState } from 'react';
import './TopBar.css';

const TopBar: React.FC = () => {

  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let widthThreshold = 620;

  let firstText = windowWidth <= 620 ? "" : "Bun venit în Neksio Land!";
  let secondText = windowWidth <= 620 ? "" : "office@neks.ro";

  return (
    <div className="top-bar">
      <div className="top-bar-section top-bar-section--blue">
        <div className="icon-and-text">
          <span>{firstText}</span>
        </div>
      </div>
      <div className="top-bar-section top-bar-section--gold">
        <div className="icon-and-text">
          <span><a href="mailto:office@neks.ro">{secondText}</a></span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
